import { FunctionComponent } from "react";
import styled from "styled-components";

import ImagePillContent from "./ImagePillContent";
import { colours } from "@/utils";
import { Device } from "@/utils/device";

const subheading =
  "For senior leaders, established founders or C-suite executives, ready to elevate their professional journey to the very top.";

const copy = [
  "Designed to enrich you on your senior leadership journey, Elevate provides the space, skills and connections needed to unlock your potential, and offers a holistic approach to leadership wellbeing that ensures you make it to the top, and thrive once you get there.",
];

const Title: FunctionComponent = () => {
  return (
    <S.Title>
      Elev<S.ItalicWrap>a</S.ItalicWrap>te
    </S.Title>
  );
};

const ElevateContent: FunctionComponent = () => {
  return (
    <ImagePillContent
      id="elevate"
      href="/elevate"
      title={<Title />}
      subheading={subheading}
      copy={copy}
      linkText="Elevate your career"
      imagePath="/images/marketing/elevate.png"
    />
  );
};

const S = () => {};

S.Title = styled.h2`
  font-size: 7rem;
  font-weight: 100;
  color: ${colours.marketingBlue};

  @media (min-width: ${Device.tablet}) {
    font-size: 8rem;
  }

  @media (min-width: ${Device.desktop}) {
    font-size: 10rem;
  }
`;

S.ItalicWrap = styled.span`
  font-style: italic;
  margin-left: -10px;
`;

export default ElevateContent;
